import React, { useContext } from "react";

import {
  Card,
  CardBody,
  Grid,
  GridItem
} from "@patternfly/react-core";
import ResourcePanelSkeleton from "./UserPanel/ResourcePanelSkeleton";
import BranchPanel from "./Branches/BranchPanel";

import { AuthContext } from "shared/context/AuthContext";

import OkdPanel from "./UserPanel/OkdPanel";
import StoragePanel from "./UserPanel/StoragePanel";
import VmPanel from "./UserPanel/VmPanel";

import { useOkdData } from "./UserPanel/Okd/hooks/useOkdData";
import { useStorageData } from "./UserPanel/Storage/hooks/useStorageData";
import { useOvirtData } from "./UserPanel/Vm/hooks/useOvirtData";

const DashboardUserResources = ({
  branches,
  branchesLoading,
  themeVersion
}) => {
  const { state } = useContext(AuthContext);
  
  const {
    data: okdData,
    loading: okdLoading,
    refetch: refetchOkd
  } = useOkdData();

  const {
    data: ovirtData,
    loading: ovirtLoading,
    refetch: refetchOvirt
  } = useOvirtData();

  const {
    data: storageData,
    loading: storageLoading,
    refetch: refetchStorage
  } = useStorageData();


  const hasOkdData = okdData?.projects?.length > 0;
  const hasOvirtData = ovirtData?.vms?.length > 0;
  const hasStorageData = Boolean(storageData);

  const showOkdSkeleton =
    state.isAuthUser &&
    okdLoading &&
    !hasOkdData;

  const showOvirtSkeleton =
    state.isAuthUser &&
    ovirtLoading &&
    !hasOvirtData;

  const showStorageSkeleton =
    state.isAuthUser &&
    storageLoading &&
    !hasStorageData;
  
  // console.log("[Dashboard] oVirt", {
  //   hookData: ovirtData,
  //   contextData: state.ovirtData,
  //   vmCount: ovirtData?.vms?.length,
  //   isOvirtAvailable:
  //     state.isOvirtAvailable,
  //   isOvirtSessionExpired:
  //     state.isOvirtSessionExpired,
  // });
  const resourcePanels = [
    state.isAuthUser &&
      (showOkdSkeleton
        ? {
            key: "okd",
            component: (
              <ResourcePanelSkeleton name="OKD" />
            )
          }
        : hasOkdData
          ? {
              key: "okd",
              component: (
                <OkdPanel
                  okdData={okdData}
                  okdLoading={okdLoading}
                  refetchOkd={refetchOkd}
                />
              )
            }
          : null),

    state.isAuthUser &&
      (showOvirtSkeleton
        ? {
            key: "vm",
            component: (
              <ResourcePanelSkeleton name="maszyn wirtualnych" />
            )
          }
        : hasOvirtData
          ? {
              key: "vm",
              component: (
                <VmPanel
                  ovirtData={ovirtData}
                  ovirtLoading={ovirtLoading}
                  refetchOvirt={refetchOvirt}
                />
              )
            }
          : null),

    state.isAuthUser &&
      (showStorageSkeleton
        ? {
            key: "storage",
            component: (
              <ResourcePanelSkeleton name="pamięci masowej" />
            )
          }
        : hasStorageData
          ? {
              key: "storage",
              component: (
                <StoragePanel
                  storageData={storageData}
                  storageLoading={storageLoading}
                  refetchStorage={refetchStorage}
                />
              )
            }
          : null)
  ].filter(Boolean);

  const branchPanels = branchesLoading
    ? [
        {
          key: "branches",
          component: (
            <ResourcePanelSkeleton name="oddziałów" />
          )
        }
      ]
    : Object.entries(branches ?? {})
        .filter(
          ([, branch]) =>
            branch?.organization_branch_published === true
        )
        .map(([branchNumber, branch]) => ({
          key: `branch-${branchNumber}`,
          component: (
            <Card isCompact isFullHeight>
              <CardBody>
                <BranchPanel
                  branch={branch}
                  isAuthUser={state.isAuthUser}
                  themeVersion={themeVersion}
                />
              </CardBody>
            </Card>
          )
        }));

  const panels = [
    ...resourcePanels,
    ...branchPanels
  ];

  if (panels.length === 0) {
    return null;
  }

  const panelSpan = panels.length === 1 ? 12 : 6;

  return (
    <Grid hasGutter>
      {panels.map((panel) => (
        <GridItem
          key={panel.key}
          span={12}
          lg={panelSpan}
        >
          {panel.component}
        </GridItem>
      ))}
    </Grid>
  );
};

export default DashboardUserResources;